var _path, _path2, _rect;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcVideoCall({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.33341 6.5H12.5001C12.8645 6.5 13.1667 6.80228 13.1667 7.16667V13.8333C13.1667 14.1977 12.8645 14.5 12.5001 14.5H3.33341C2.96903 14.5 2.66675 14.1977 2.66675 13.8333V7.16667C2.66675 6.80228 2.96903 6.5 3.33341 6.5Z",
    stroke: "#00A9FC",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.1667 8.98282L17.3334 7.68282V13.3171L15.1667 12.0171V8.98282Z",
    stroke: "#00A9FC",
    strokeWidth: 2
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 15.9861,
    y: 9.41296,
    width: 0.604492,
    height: 2.31689,
    fill: "#00A9FC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcVideoCall);
export default __webpack_public_path__ + "static/media/ic_video_call.99406f622555effaccefa9959b2e1c70.svg";
export { ForwardRef as ReactComponent };